<div class="dqf-review page gray-font-color font-family">
  <div class="header-navigation-back" >
    <div class="back-icon" (click)="backAction()" style="flex: 0 0 5%">
      <mat-icon svgIcon="left-arrow"></mat-icon>
    </div>
    <div  class="header-text">Report Incident for {{ carrierCompanyName }}</div>
  </div>
  <div class="new-claim-container">
    @if (!loading) {
      <mat-horizontal-stepper [linear]="true" #stepper>
        <mat-step>
          <app-accident-details></app-accident-details>
          <div class="step-actions margin-top-sm">
            <button mat-raised-button color="primary" matStepperNext (click)="onNextStep()">
              Next
            </button>
          </div>
        </mat-step>
        
        <mat-step>
          <app-authority-contacted></app-authority-contacted>
          <div class="step-actions margin-top-sm">
            <button mat-button matStepperPrevious>Back</button>
            <button mat-raised-button color="primary" matStepperNext (click)="onNextStep()">
              Next
            </button>
          </div>
        </mat-step>
        
        <mat-step>
          <app-property-damage-detail></app-property-damage-detail>
          <div class="step-actions margin-top-sm">
            <button mat-button matStepperPrevious>Back</button>
            <button mat-raised-button color="primary" matStepperNext (click)="onNextStep()">
              Next
            </button>
          </div>
        </mat-step>
        
        <mat-step>
          <app-injured-details></app-injured-details>
          <div class="step-actions margin-top-sm">
            <button mat-button matStepperPrevious>Back</button>
            <button mat-raised-button color="primary" matStepperNext (click)="onNextStep()">
              Next
            </button>
          </div>
        </mat-step>
        
        <mat-step>
          <app-witness-details></app-witness-details>
          <div class="step-actions margin-top-sm">
            <button mat-button matStepperPrevious>Back</button>
            <button mat-raised-button color="primary" matStepperNext (click)="onNextStep()">
              Next
            </button>
          </div>
        </mat-step>
        
        <mat-step>
          <div class="document">
            <h2 class="mat-h2">Upload Supporting Documents</h2>
            <button mat-raised-button color="primary" class="upload margin-top-sm margin-bottom-sm">
              Upload Document
            </button>
            <p class="empty-msg margin-top-md">No Documents uploaded yet</p>
          </div>
          <div class="step-actions margin-top-sm">
            <button mat-button matStepperPrevious>Back</button>
            <button mat-raised-button color="primary" (click)="onSubmit()">
              Submit
            </button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    }
  </div>
</div>
